import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Typography } from '@material-ui/core';
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined';

import useStyles from './styles';
import { useIsDesktop } from 'components/utilities';

const Place = ({ title }) => {
	const styles = useStyles();
	const isDesktop = useIsDesktop();

	const size = isDesktop ? 'large' : 'small';
	const variant = isDesktop ? 'h4' : 'h6';

	const boxPaddings = {
		px: isDesktop ? 3 : 2,
		py: isDesktop ? 2 : 1,
	};

	return (
		<Box {...boxPaddings} className={styles.root}>
			<Grid container spacing={2} alignItems="center">
				<Grid item xs="auto">
					<PlaceOutlinedIcon size={size} className={styles.icon} />
				</Grid>
				<Grid item xs="auto">
					<Typography variant={variant}>{title}</Typography>
				</Grid>
			</Grid>
		</Box>
	);
};

Place.propTypes = {
	title: PropTypes.string,
};

export default Place;
